import type { UrlDialog } from '@/hooks/url-dialog';

import { useUrlDialog, useUrlDialogTarget } from '@/hooks/url-dialog';

/** Which of the parent detail dialogs a link points at. */
export type ParentDetailKind = 'assignment' | 'quiz';

const IDENTITY_KEYS = ['child', 'item'] as const;

export interface ParentDetailTarget {
  childId: number;
  itemId: string;
  close: () => void;
}

/**
 * What a card writes to the URL when a parent opens it.
 *
 * The child is part of the identity because ids repeat across siblings — the
 * same assignment set to two children is two rows carrying one id.
 */
export function useParentDetailDialog(kind: ParentDetailKind, childId: number, itemId: string | number): UrlDialog {
  return useUrlDialog(kind, { child: childId, item: itemId });
}

/** The dialog side: which record the URL asks for, if it asks for one. */
export function useParentDetailTarget(kind: ParentDetailKind): ParentDetailTarget | undefined {
  const target = useUrlDialogTarget(kind, [...IDENTITY_KEYS]);
  if (!target) return undefined;

  const childId = Number(target.params.child);
  if (!Number.isInteger(childId) || childId <= 0) return undefined;

  return { childId, itemId: target.params.item, close: target.close };
}
